import {requestQuote, bestReceiveAmount, quoteFailure} from './quote-request.js?v=token-fix-20261009';
export {bestReceiveAmount, estimateFailure} from './quote-request.js?v=token-fix-20261009';

export function createReceiveEstimate(React) {
  return function useReceiveEstimate(amount, from, to) {
    const key = `${amount}|${from}|${to}`;
    const [result, setResult] = React.useState({key:'',status:'idle'});
    const valid = Number.isFinite(Number(amount)) && Number(amount) > 0 && from !== to;
    React.useEffect(() => {
      if (!valid) return;
      const controller = new AbortController();
      let active = true;
      const timer = setTimeout(async () => {
        setResult({key,status:'loading'});
        const split = value => { const [ticker,...network] = value.split('_'); return [ticker,network.join('_')]; };
        const [tickerFrom,networkFrom] = split(from), [tickerTo,networkTo] = split(to);
        try {
          const body = await requestQuote({tickerFrom,tickerTo,networkFrom,networkTo,amountFrom:amount}, {signal:controller.signal});
          const value = bestReceiveAmount(body);
          if (active) setResult({key,status:'ready',value});
        } catch (error) {
          if (active) setResult({key,status:'error',message:quoteFailure(error)});
        }
      },600);
      return () => {active=false;clearTimeout(timer);controller.abort();};
    },[key,valid]);
    // Never display a quote for a previously selected amount or network.
    if (!valid) return {status:'idle'};
    return result.key === key ? result : {status:'loading'};
  };
}
